<template>
    <img width=100% src = "@/assets/images/healthyAI_poster.jpg" alt="poster"/>
</template>
<script>
import { onMounted, defineComponent } from 'vue'
export default defineComponent({
    name: 'HomePage',
    setup() {
        onMounted(() => {
        })
        return {
        }
    }
});
</script>